module.exports = __webpack_public_path__ + "img/J12119.4099dba6.png";